type ConversationWithPayload = {
  payload?: unknown;
};

export const isConversationContactBlocked = (
  conversation?: ConversationWithPayload
): boolean => {
  if (!conversation) {
    return false;
  }

  const { payload } = conversation;

  return (
    typeof payload === "object" &&
    payload !== null &&
    "action" in payload &&
    payload.action === "blocked"
  );
};
